// Converted from application/views/home_v.php. Edit this component directly.
export default function HomePage() {
  return <><h1>{"WORKS OF PADDY CAMPBELL"}</h1>
<div class={"row"}>
<div class={"column solo"}>
<div class={"calltoactionContainer"} style={{"backgroundImage":"url(/assets/images/home/paddys-hands.jpeg)"}}>
<div class={"calltoactionWrp"}>
<a href={"/c/works"}>{"See all"}</a>
</div>
</div>
</div>
</div>
<style>{"\n    .china-feature-images {\n        position: relative;\n    }\n    .china-feature-images img {\n        aspect-ratio: 3 / 4;\n        object-fit: cover;\n    }\n    .china-feature-images .calltoactionWrp {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        pointer-events: none;\n    }\n    .china-feature-images .calltoactionWrp a {\n        pointer-events: auto;\n    }\n"}</style>
<div class={"row china-feature-images"}>
<div class={"column"}>
<figure>
<img src={"/assets/images/china-exhibition/Banner-china.jpg"} alt={"La Forma e l'Invisibile exhibition poster"} />
</figure>
</div>
<div class={"column"}>
<figure>
<img src={"/assets/images/china-exhibition/Wind&Sea-36.jpg"} alt={"Wind and Sea, a bronze sculpture by Paddy Campbell"} />
<figcaption>{"Wind & Sea"}</figcaption>
</figure>
</div>
<div class={"calltoactionWrp"}>
<a href={"/c/next_exhibition/china_2026"}>{"\n            Next exhibition in"}<br />{"Hangzhou, China\n        "}</a>
</div>
</div>
<div class={"row"}>
<div class={"column"}>
<div class={"calltoactionContainer"} style={{"backgroundImage":"url(/assets/images/home/paddy-at-work.jpg)"}}>
<div class={"calltoactionWrp"}>
<a href={"/c/bio"}>{"\n                    Meet the artist\n                "}</a>
</div>
</div>
</div>
<div class={"column"}>
<div class={"calltoactionContainer"} style={{"backgroundImage":"url(/assets/images/home/rony_reading.jpg)"}}>
<div class={"calltoactionWrp"}>
<a target={"_blank"} href={"https://www.instagram.com/paddycampbell_sculptor/"} rel="noopener noreferrer">{"Follow us"}<br />{"On Instagram"}</a>
</div>
</div>
</div>
</div>
</>;
}
